import cartItemsDuck from 'components/cart/cart-items/duck'
import { trackViewCartEvent } from 'components/header/utils'

// Reuse the existing bag, preserving voucher and store-credit selections.
const openPdpBag = (cart) => (dispatch, getState) => {
  if (!cart) return
  dispatch(
    cartItemsDuck.creators.update({
      ...getState().cartData,
      cartOpen: true,
      freeGiftOpen: false,
    }),
  )
  trackViewCartEvent(cart)
}

export default openPdpBag
